module.exports = __webpack_public_path__ + "static/media/42.7ee0b33f.png";